import type { SVGProps } from 'react'
const IconStoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.606 11.569A3.755 3.755 0 0 1 14.9 7.863a.75.75 0 1 1 1.5 0 2.235 2.235 0 0 0 2.206 2.206 2.49 2.49 0 0 0 1.793-.84 1.59 1.59 0 0 0 .421-1.26 21 21 0 0 0-.853-3.1 1.68 1.68 0 0 0-1.6-1.15H7.027a1.68 1.68 0 0 0-1.6 1.16 21 21 0 0 0-.837 3.09 1.58 1.58 0 0 0 .42 1.259 2.48 2.48 0 0 0 1.8.84 2.235 2.235 0 0 0 2.205-2.206.75.75 0 0 1 1.5 0 3.755 3.755 0 0 1-3.71 3.707 3.99 3.99 0 0 1-2.93-1.358 3.05 3.05 0 0 1-.769-2.455c.212-1.138.513-2.257.9-3.347a3.18 3.18 0 0 1 3.025-2.19h11.343a3.18 3.18 0 0 1 3.021 2.174c.394 1.094.7 2.219.914 3.362a3.06 3.06 0 0 1-.772 2.458 4 4 0 0 1-2.93 1.356"
    />
    <path
      fill="currentColor"
      d="M12.704 11.568a3.71 3.71 0 0 1-3.706-3.706v-.925a.75.75 0 1 1 1.5 0v.925a2.206 2.206 0 0 0 4.411 0v-.925a.75.75 0 0 1 1.5 0v.925a3.71 3.71 0 0 1-3.705 3.706"
    />
    <path
      fill="currentColor"
      d="M17.756 21.716h-10.1a3.64 3.64 0 0 1-3.635-3.618v-7.982a.75.75 0 1 1 1.5 0v7.978a2.14 2.14 0 0 0 2.138 2.122h10.076a2.2 2.2 0 0 0 1.518-.617 2.12 2.12 0 0 0 .636-1.507V10.11a.75.75 0 1 1 1.5 0v7.985a3.636 3.636 0 0 1-3.636 3.622z"
    />
    <path
      fill="currentColor"
      d="M17.139 14.352a.747.747 0 0 1-.75-.745v-.01a.75.75 0 1 1 .75.755M15.284 21.705a.75.75 0 0 1-.75-.75v-3.648a1.83 1.83 0 1 0-3.661 0v3.648a.75.75 0 0 1-1.5 0v-3.648a3.33 3.33 0 0 1 6.661 0v3.648a.75.75 0 0 1-.75.75"
    />
  </svg>
)
export default IconStoreIcon
